module.exports = __webpack_public_path__ + "img/Close - Green - Selected.eded00fa.png";